import { Component, OnInit } from '@angular/core';
import { BooleanEditorComponent } from 'src/app/common/ag-grid-table/cell-editors/boolean/boolean.component';
import { CalendarEditorComponent } from 'src/app/common/ag-grid-table/cell-editors/calendar/calendar.component';
import { ColorTextComponent } from 'src/app/common/ag-grid-table/cell-editors/color-text/color-text.component';
import { DropdownEditorComponent } from 'src/app/common/ag-grid-table/cell-editors/dropdown/dropdown.component';
import { LineItemEditorComponent } from 'src/app/common/ag-grid-table/cell-editors/line-item/line-item.component';
import { MultiselectEditorComponent } from 'src/app/common/ag-grid-table/cell-editors/multiselect/multiselect.component';
import { LineItemCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/line-item/line-item.component';
import { LinkCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/link/link.component';
import { MiscAssetCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/misc-asset/misc-asset.component';
import { RefsCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/refs/refs.component';
import { TextCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/text/text.component';
import { ThumbnailCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/thumbnail/thumbnail.component';
import { AgGridToolsService } from 'src/app/common/ag-grid-table/services/ag-grid-tools.service';
import { DynamicCardType } from 'src/app/common/components/dynamic-form-v2/enums/DynamicCardType';
import { BaseDynamicViewComponent } from 'src/app/common/components/dynamic-view-v2/components/base-dynamic-form/base-dynamic-view.component';
import { BaseViewFieldType } from 'src/app/common/components/dynamic-view-v2/enums/BaseViewFieldType';
import { DynamicViewType } from 'src/app/common/components/dynamic-view-v2/enums/DynamicViewType';
import BaseEntityDto from 'src/app/common/dtos/BaseEntityDto';
import { UtilitiesService } from 'src/app/common/services/utilities.service';

@Component({
  selector: 'app-release-progression-levels-v2',
  templateUrl: './release-progression-levels-v2.component.html',
  styleUrls: ['./release-progression-levels-v2.component.sass']
})
export class ReleaseProgressionLevelsV2Component extends BaseDynamicViewComponent implements OnInit {
  progressionLevelRecord: BaseEntityDto = new BaseEntityDto();
  entity: any;
  options: any = {};
  prizeCounts: { [key: string]: number } = {};
  parentViewName: string = 'releaseProgressionLevel'
  isLoading: boolean = false; // Agrega esta propiedad aquí
  constructor(
    private agGridToolsService: AgGridToolsService,
    private utilitiesService: UtilitiesService
  ) {
    super();
  }
  async ngOnInit(): Promise<void> {
    this.fields = [
      {
        title: 'Progression Level Data',
        fields: [
          {
            name: 'Name',
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Text],
            clearField: true,
            key: 'name',
            isRequired: true,
            label: 'Name',
            columnWidth: 6,
          },
          {
            name: 'Design Value',
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Text],
            clearField: true,
            key: 'designValue',
            isRequired: true,
            label: 'Design Value',
            columnWidth: 6,
          },
          {
            name: 'Level',
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Text],
            clearField: true,
            key: 'level',
            isRequired: true,
            label: 'Level',
            columnWidth: 6,
          },   
          {
            name: 'Tags',
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Text],
            clearField: true,
            key: 'tags',
            isRequired: true,
            label: 'Tags',
            columnWidth: 6,
          },         
          {
            name: 'Start Date/Time',
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Calendar],
            clearField: true,
            key: 'start',
            label: 'Start Date/Time',
            columnWidth: 6,
          },
          {
            name: 'End Date/Time',
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.Calendar],
            clearField: true,
            key: 'end',
            label: 'End Date/Time',
            columnWidth: 6,
          },
          {
            name: 'Internal Notes',
            inputType: DynamicViewType.BaseViewField,
            viewTypes: [BaseViewFieldType.RichText],
            clearField: false,
            key: 'copy',
            label: 'Internal Notes',
            columnWidth: 12,
          },
        ],
        type: DynamicCardType.Card,
      },
      {
        title: 'Reward(s)',
        type: DynamicCardType.Card,
        fields: [
          // PRIZES
          {
            name: "Prizes(s)", 
            inputType: DynamicViewType.AgGridTable,
            key: 'rewards_ref', 
            label: 'Prizes(s)',
            options: {
              title: 'Prizes(s)',
              fieldName: '',
              isPrize: true,
              identifier: `${this.parentViewName}-prizes`,
              columnDefs: [
                {
                  headerName: 'ID',
                  field: 'id',
                  width: 125,
                  headerCheckboxSelection: true,
                  checkboxSelection: true,
                  sortable: true,
                  initialSort: 'desc',
                  sortIndex: 0,
                  initialSortIndex: 0,
                  sort: 'desc',
                  sortingOrder: ['asc', 'desc'],
                  unSortIcon: false,
                  filter: 'agNumberColumnFilter',
                  filterParams: {
                    filterOptions: [
                      'equals',
                      'notEqual',
                      'lessThan',
                      'lessThanOrEqual',
                      'greaterThan',
                      'greaterThanOrEqual',
                      'inRange'
                    ]
                  },
                  resizable: true,
                  floatingFilter: true,
                  suppressSizeToFit: true,
                },
                {
                  headerName: 'Name',
                  field: 'name',
                  cellRendererParams: {
                    entity: this.entity,
                    isMultiple: true,
                    entities: ['items', 'currencies']
                  },
                  cellRenderer: LinkCellRendererComponent,
                  sortable: true,
                  unSortIcon: true,
                  resizable: true,
                  filter: 'agTextColumnFilter',
                  floatingFilter: true,
                  cellEditor: 'agTextCellEditor',
                  type: 'editableColumn',
                },  
                {
                  headerName: 'Quantity',
                  field: 'prizeCounts',
                  sortable: true,
                  unSortIcon: true,
                  suppressSizeToFit: true,
                  cellRenderer: TextCellRendererComponent,
                  cellRendererParams: {
                    entity: this.entity,
                    isPill: true
                  },
                  valueGetter: (params: any) => {
                    const prizeCounts = params.data.prizeCounts;
                    return prizeCounts !== undefined ? prizeCounts : 'Not Available';
                  },
                  resizable: true,
                  width: 150 
                },
                {
                  headerName: 'Enabled',
                  field: 'enabled',
                  cellRenderer: TextCellRendererComponent,
                  cellRendererParams: {
                    onLabel: 'Enabled',
                    offLabel: 'Not Enabled',
                    isBoolean: true
                  },
                  sortable: true,
                  unSortIcon: true,
                  resizable: true,
                  filter: 'agSetColumnFilter',
                  filterParams: {
                    values: [true, false],
                    valueFormatter: (params: any) => params.value ? 'Enabled' : 'Not Enabled'
                  },
                  floatingFilter: true,
                  cellClass: 'center-cell-content',
                },
                {
                  headerName: 'Thumbnail Record',
                  field: 'thumbnail_ref',
                  cellRenderer: MiscAssetCellRendererComponent,
                  sortable: true,
                  unSortIcon: true,
                  resizable: true,
                  filter: 'agTextColumnFilter',
                  floatingFilter: true,
                  filterParams: {
                    filterKey: 'thumbnail_ref',
                    isAggregate: true,
                    fieldKeys: ['name', 'id', 'path'],
                    isMiscBuild: true,
                    populate: true,
                    select: '_id id name path thumbnails'
                  },
                  width: 500,
                  autoHeight: true,
                },
                {
                  headerName: 'Thumbnail',
                  field: 'thumbnail_img',
                  sortable: false,
                  resizable: true,
                  width: 135,
                  autoHeight: true,
                  cellRenderer: ThumbnailCellRendererComponent,
                  cellRendererParams: {
                    tableIdentifier: `${this.parentViewName}-prizes`,
                  },
                  valueGetter: (params: any) => {
                    let thumbnailPath = '';
                    if (params.data.thumbnail_ref && params.data.thumbnail_ref.thumbnails) {
                      thumbnailPath = params.data.thumbnail_ref.thumbnails.find((th: { size: number; }) => th.size === 256)?.path;
                    }
                    else if (params.data.thumbnails) {
                      thumbnailPath = params.data.thumbnails.find((th: { size: number; }) => th.size === 256)?.path;
                    }
                    else if (params.data.image_ref && params.data.image_ref.thumbnails) {
                      thumbnailPath = params.data.image_ref.thumbnails.find((th: { size: number; }) => th.size === 256)?.path;
                    }
                    else if (params.data.flyUpAnimation_ref && params.data.flyUpAnimation_ref.thumbnails) {
                      thumbnailPath = params.data.flyUpAnimation_ref.thumbnails.find((th: { size: number; }) => th.size === 256)?.path;
                    }
                    else if (params.data.thumbnail_ref && params.data.thumbnail_ref.thumbnails) {
                      thumbnailPath = params.data.thumbnail_ref.thumbnails.find((th: { size: number; }) => th.size === 128)?.path;
                    }
                    else if (params.data.imagePreview) {
                      thumbnailPath = params.data.imagePreview;
                    }
                    return thumbnailPath || 'https://d3tfb94dc03jqa.cloudfront.net/thumbnails/narrow_thumbnail_placeholder.jpeg';
                  },
                },                                            
                {
                  headerName: 'Start',
                  field: 'start',
                  sortable: true,
                  unSortIcon: true,
                  filter: 'agDateColumnFilter',
                  floatingFilter: true,
                  suppressSizeToFit: true,
                  width: 300,
                  cellRenderer: TextCellRendererComponent,
                  cellRendererParams: {
                    isDate: true,
                  },
                  valueGetter: this.agGridToolsService.dateValueGetter('start'),
                  resizable: true,
                  cellClass: 'center-cell-content',
                },
                {
                  headerName: 'End',
                  field: 'end',
                  sortable: true,
                  unSortIcon: true,
                  filter: 'agDateColumnFilter',
                  floatingFilter: true,
                  suppressSizeToFit: true,
                  cellRenderer: TextCellRendererComponent,
                  cellRendererParams: {
                    isDate: true,
                    timePill: true
                  },
                  width: 300,
                  valueGetter: this.agGridToolsService.dateValueGetter('end'),
                  resizable: true,
                  cellClass: 'center-cell-content',
                },
                {
                  headerName: 'Content Status',
                  field: 'itemStatus',
                  cellRenderer: TextCellRendererComponent,
                  sortable: true,
                  unSortIcon: true,
                  resizable: true,
                  filter: 'agSetColumnFilter',
                  filterParams: {
                    values: ['Approved', 'Awaiting Revision', 'QA Ready'],
                    addEmptyFilters: true,
                  },
                  floatingFilter: true,

                  cellEditor: DropdownEditorComponent,
                  cellEditorParams: {
                    isFlatList: true
                  },
                  type: 'editableColumn',
                },
                {
                  headerName: 'Art Status',
                  field: 'vendorStatus',
                  cellRenderer: TextCellRendererComponent,
                  sortable: true,
                  unSortIcon: true,
                  resizable: true,
                  filter: 'agSetColumnFilter',
                  filterParams: {
                    values: ['Assigned', 'In Revision', 'Approved'],
                    addEmptyFilters: true,
                  },
                  floatingFilter: true,

                  cellEditor: DropdownEditorComponent,
                  cellEditorParams: {
                    isFlatList: true
                  },
                  type: 'editableColumn',
                },
                {
                  headerName: 'Promotion Status',
                  field: 'isAssetUpToDate',
                  cellRenderer: TextCellRendererComponent,
                  sortable: true,
                  unSortIcon: true,
                  resizable: true,
                  valueGetter: (params: any) => {
                    const lastHash = params.data.prefab_ref?.lastHash;
                    const versions = params.data.prefab_ref?.asset_versions;
                    const lastVersion = versions ? versions[versions.length - 1] : null;

                    let response = 'No data';

                    if (!lastHash && versions && versions.length > 0) {
                      return 'Outdated';
                    }

                    if (lastHash && versions && versions.length > 0) {
                      response = lastVersion.destinationPath.includes(lastHash) ? 'Up to date' : 'Outdated';
                    }
                    return response;
                  },
                  filter: 'agSetColumnFilter',
                  filterParams: {
                    values: [
                      'No data', 'Outdated', 'Up to date'
                    ],
                    addEmptyFilters: true,
                    isAggregate: true,
                    filterKey: 'prefab_ref',
                    isAssetUpToDate: true,
                  },
                  floatingFilter: true,

                },
              ],
                isMultiple: true,
                entity: 'releases-v2',
                defaultQueryKey: 'rewards_ref',
                entities: ['items', 'currencies'],
                customHeight: '60vh',
                select: '_id id name start end enabled isAssetUpToDate vendorStatus itemStatus thumbnail_ref thumbnail_img',
            }
          },
        ]
      },
    ];
    this.progressionLevelRecord = {
      enabled: false,
    };

    this.title = 'Releases Progression Level';
    this.viewRoute = 'releases-progression-level';
    this.isLoading = false;
  }
}
